import {
  getAppListAsync,
  getCalcSymbol,
  getCustomerListAsync,
  getCustomerType,
  getDivisionListAsync,
  getFormStatus,
  getFrameSizeAsync,
  getIndustryListAsync,
  getStatus,
} from '@/services/rebate-api/common';
import { create } from 'zustand';
export interface CommonDto {
  id: string;
  code: string;
  name: string;
  value: string;
  /** 产品系列ID */
  seriesId?: number;
  seriesIds?: number[];
  children?: CommonDto[];
}
interface BaseConfig {
  customerType?: CommonDto[];
  status?: CommonDto[];
  formStatus?: CommonDto[];
  divisionList?: CommonDto[];
  customerList?: CommonDto[];
  calcSymbol?: CommonDto[];
  frameSizes?: CommonDto[];
  industryList?: CommonDto[];
  appList?: CommonDto[];
}

interface BaseConfigStore extends BaseConfig {
  baseConfig: BaseConfig;
  getConfigAsync: () => Promise<void>;
}

export const useBaseConfigStore = create<BaseConfigStore>((set, get) => ({
  baseConfig: {} as BaseConfig,
  getConfigAsync: async () => {
    const res = await Promise.all([
      getCustomerType(),
      getStatus(),
      getFormStatus(),
      getDivisionListAsync(),
      getCustomerListAsync({}),
      getCalcSymbol({}),
      getFrameSizeAsync(),
      getIndustryListAsync(),
      getAppListAsync(),
    ]);
    set({
      baseConfig: {
        customerType: res[0],
        status: res[1],
        formStatus: res[2],
        divisionList: res[3],
        customerList: res[4],
        calcSymbol: res[5],
        frameSizes: res[6],
        industryList: res[7],
        appList: res[8],
      },
    });
  },
}));
